//cookie_consent
if (typeof $ === 'function' && typeof $.cookie === 'function') {

  if (!$.cookie('cookie_consent')) {

    $('body').append('<div class="cookie_consent font-small px-5 py-3 d-print-none" id="cookie_consent">'
      + 'Ypsilonka používá cookies. Používáním webu vyjadřujete souhlas s&nbsp;jejich ukládáním na vašem zařízení. '
      + '<a href="/ochrana-osobnich-udaju#cookies" class="cookie_consent--link">Více informací</a> '
      + '<br class="d-lg-none"><button class="cookie_consent--btn btn btn-warning font-small ml-lg-3 my-3 my-lg-0" id="cookie_consent_ok">Rozumím</button><div>');

    $('#cookie_consent_ok').on('click', function () {
      $.cookie('cookie_consent', 1, { expires: 365, path: '/' });
      $('#cookie_consent').fadeOut(470, function () {
        $(this).remove();
      });
      return false;
    });

  }

}
